<template>
    <div class="color-size-error-wrapper">
        <div class="color-size-wrapper" :class="{'color-size-wrapper--invalid': !(isValidColor && isValidSize) && !showValidation}">
            <select-option
                name="product_color"
                id="product_color"
                :options="colors"
                :selectedValue="selectedColorId"
                defaultValue="Select Color"
                :isPristine="pristineStatus['color']"
                @change="event => $emit('color-changed', event)"
                v-if="hasColors"
            />
            <select-option
                name="product_size"
                id="product_size"
                :options="sizes"
                :selectedValue="selectedSizeId"
                :disabled="!hasColorSelected"
                defaultValue="Select Size"
                :isPristine="pristineStatus['size']"
                @change="sizeChanged"
                @click="sizeClicked"
            >
                <template v-slot:option-sidetitle="slotProps">
                    <span class="oos-size-message" v-if="showOOSMessage(slotProps.option)">
                        - Please choose another size
                    </span>
                </template>
            </select-option>
        </div>
        <span v-if="showValidation" v-show="validationMessage" class="color-size-error">
            {{ validationMessage }}
        </span>
    </div>
</template>

<script>
    import SelectOption from './select-option.vue';

    export default {
        props: {
            colors: Array,
            sizes: Array,
            selectedColorId: String,
            selectedSizeId: String,
            isPristine: Object,
            showValidation: Boolean,
        },
        components: { SelectOption },
        data() {
            return {
                isColorPristine: true,
                isSizePristine: true,
            };
        },
        computed: {
            hasSizes() {
                return this.sizes && this.sizes.length > 0
            },
            hasColors() {
                return this.colors && this.colors.length > 1
            },
            hasColorSelected () {
                return !!this.selectedColorId || !this.hasColors;
            },
            hasSizeSelected () {
                return !!this.selectedSizeId || !this.hasSizes;
            },
            isSizeOOS() {
                const size = this.sizes.find(size => size.product_option_value_id === this.selectedSizeId);
                return size && size.in_stock == 0;
            },
            isValid() {
                return this.hasSizeSelected && this.hasColorSelected;
            },
            pristineStatus() {
                if(!this.isPristine){
                    return {
                        'size': this.isSizePristine,
                        'color': this.isColorPristine,
                    };
                } else {
                    return {
                        'size': this.isPristine && this.isPristine['size'],
                        'color': this.isPristine && this.isPristine['color'] && this.isColorPristine,
                    };
                }
            },
            isValidSize() {
                return this.hasSizeSelected || this.pristineStatus['size'];
            },
            isValidColor() {
                return this.hasColorSelected || this.pristineStatus['color'];
            },
            validationMessage() {
                if(!this.isValidSize && !this.isValidColor) {
                    return 'Please select your color and size';
                } else if(!this.isValidColor){
                    return 'Please select your color';
                } else if(!this.isValidSize){
                    return 'Please select your size';
                }

                return '';
            },
        },
        methods: {
            showOOSMessage(option) {
                return this.isSizeOOS && option.product_option_value_id === this.selectedSizeId;
            },
            sizeClicked() {
                this.isColorPristine = false;
            },
            sizeChanged(event) {
                this.$emit('size-changed', event);
                this.isSizePristine = false;
            }, 
        },
        watch: {
            sizes: {
                immediate: true,
                handler(value, oldValue) {
                    if(!this.selectedSizeId && value.length === 1 && value != oldValue) {
                        this.$emit('size-changed', {
                            target: {
                                value: value[0].product_option_value_id
                            }
                        })
                    }
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .color-size-wrapper {
        display: flex;
        &.color-size-wrapper--invalid {
            flex-direction: column;
            > :nth-child(1) {
                margin-bottom: 12px;
            }
        }
    }
    .oos-size-message {
        font-size: 13px;
    }
    .color-size-error-wrapper {
        text-align: center;
        margin-bottom: 10px;
    }
</style>
